// @ts-nocheck
import React from "react";
import FormInput from "../Componentes/FormInput";
import FormInputMultiline from "../Componentes/FormInputMultiline";
import Adjuntos from "../Difusiones/Componentes/Adjuntos";
import { FormSelect } from "../Componentes/FormSelect";
import { MAX_SIZE_FILES_osticket } from "../Contantes/Constantes";

const SoporteApps = (props) => {
  const { value, setValue, servicios } = props;

  const onChange = (e) => {
    setValue({
      ...value,
      [e.target.name]: e.target.value,
    });
  };
  const onChangeServicio = async (e) => {
    const num = e.target.value;
    setValue({
      ...value,
      servicio: num.toString(),
    });
  };

  const agregarAdjuntos = async (file) => {
    let e = {
      target: {
        name: "adjuntos",
        value: file, //fileAPI
      },
    };
    onChange(e);
  };

  return (
    <>
      <FormSelect
        name="servicio"
        label="Servicio"
        selectedValue={value.servicio}
        onChange={onChangeServicio}
        items={servicios}
      />
      <FormInput
        name="asunto"
        label="Asunto"
        value={value.asunto}
        onChange={onChange}
        fullWidth
        onKeyPress={(e) => {
          e.key === "Enter" && e.preventDefault();
        }}
      />
      <FormInputMultiline
        name="descripcion"
        label="Descripcion"
        value={value.descripcion}
        onChange={onChange}
        // onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault()}}
      />
      <div>
        <Adjuntos
          size={MAX_SIZE_FILES_osticket}
          name="adjuntos"
          files={value.adjuntos}
          agregarAdjuntos={agregarAdjuntos}
        />
      </div>
    </>
  );
};
export default SoporteApps;
